export const TERTIARY = {
  DEFAULT: '#9BBE3C',
  LIGHT: '#DDE995',
  LIGHTER: '#EAF6B9',
  LIGHTEST: '#F6FAE7',
} as const;
